//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SelectJoint.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"Attachment",1,0],[1,"FirstJoint",0,"Motion.SelectJoint",0],[1,"FirstScaleExpression",0,"Expression",0],[0,"FirstType",1,0],[0,"Name",1,0],[1,"SecondJoint",0,"Motion.SelectJoint",0],[1,"SecondScaleExpression",0,"Expression",0],[0,"SecondType",1,0],[1,"ThirdJoint",0,"Motion.SelectJoint",0],[1,"ThirdScaleExpression",0,"Expression",0],[0,"ThirdType",1,0]],[],[]];
SPLM.Motion.GeneralCouplerBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.GeneralCouplerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.GeneralCouplerBuilder.AttachmentType = Object.freeze({
    "Two" : "Two", "Three" : "Three"});

export default SPLM;